import type { QueryMessage } from '../../core/types/workspaceTypes';
import {
  isRowsAffectedMessage,
  isUserPrintMessage,
  shouldFilterMessage,
} from './plaintextResultsUtils';

export { isUserPrintMessage, hasUserPrintMessages } from './plaintextResultsUtils';

export type OutputLine =
  | { kind: 'message'; message: QueryMessage }
  | { kind: 'placeholder'; index: number };

export function buildOutputLines(
  messages: QueryMessage[] | undefined,
  resultSetCount: number,
): OutputLine[] {
  const sorted = [...(messages ?? [])]
    .filter((m) => !shouldFilterMessage(m.content))
    .sort((a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime());

  const lines: OutputLine[] = [];
  let placeholderIndex = 0;
  const hasRowsAffectedAnchor = sorted.some((m) => isRowsAffectedMessage(m.content));

  if (hasRowsAffectedAnchor) {
    for (const msg of sorted) {
      if (isRowsAffectedMessage(msg.content) && placeholderIndex < resultSetCount) {
        lines.push({ kind: 'placeholder', index: placeholderIndex });
        placeholderIndex += 1;
      }
      lines.push({ kind: 'message', message: msg });
    }
  } else {
    for (const msg of sorted) {
      lines.push({ kind: 'message', message: msg });
      if (isUserPrintMessage(msg) && placeholderIndex < resultSetCount) {
        lines.push({ kind: 'placeholder', index: placeholderIndex });
        placeholderIndex += 1;
      }
    }
  }

  while (placeholderIndex < resultSetCount) {
    lines.push({ kind: 'placeholder', index: placeholderIndex });
    placeholderIndex += 1;
  }

  return lines;
}
